// extracted by mini-css-extract-plugin
export default {"typeSelectorBox":"RadioButton_typeSelectorBox__3urR2","typSelectorSelected":"RadioButton_typSelectorSelected__9SsiG"};